module.exports = __webpack_public_path__ + "img/caldero-item.3f647138.png";